module.exports = __webpack_public_path__ + "static/img/webpos.55449b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/webpos.png
// module id = Tod1
// module chunks = 0